import { cx } from 'cvb';
import PropTypes from 'prop-types';
import AddToCartButton from '../../../../../../components/AddToCartButton/Desktop/AddToCartButtonDesktop';
import MyLists from '../../../../../../components/MyLists/MyLists';
import Warning from '../../../../../../components/Warning/Warning';
import _ from '../../../../../../utils/LodashImports';
import { noop } from '../../../../../../utils/noop';
import GenericCalculatorContainer from '../../../../../GenericCalculatorContainer/GenericCalculatorContainer';
import { useProductQuantitySelection } from '../hooks/useProductQuantitySelection';
import { ProductQuantitySelectionContainerStyle } from './style';

const ProductQuantitySelectionContainer = (props) => {
  const hookData = useProductQuantitySelection(props);

  const {
    shouldShowCalculator,
    shouldShowAddToCart,
    shouldShowError,
    isLoading,
    addToCartButtonProps,
    calculatorProps,
    warningProps,
    myListProps,
    hasRequiredData,
  } = hookData;

  const isMyListsEnabled = _.get(props.appCtx, 'siteConfig.toggles.isPDPMyListsEnabled', false);

  if (!hasRequiredData) {
    return null;
  }

  return (
    <div className="product-quantity-selection">
      {/* Main horizontal container for quantity selector and add to cart */}
      <div className="product-quantity-selection__main-row">
        {/* Calculator Section - BEM Element */}
        {shouldShowCalculator && (
          <div className="product-quantity-selection__calculator">
            <GenericCalculatorContainer {...calculatorProps} />
          </div>
        )}

        {/* Add to Cart Section - BEM Element */}
        {shouldShowAddToCart && (
          <div
            className={cx('product-quantity-selection__add-to-cart', {
              'product-quantity-selection__add-to-cart--loading': isLoading,
            })}
            data-testid="product-quantity-selection__add-to-cart"
          >
            {/* Add to Cart Button Container */}
            <div className="product-quantity-selection__button-container">
              <AddToCartButton {...addToCartButtonProps} showMaxQuantityLabel={false} />
            </div>
          </div>
        )}

        {/* Favorites/Wishlist - Only show if toggle is enabled */}
        {isMyListsEnabled && (
          <div className="product-quantity-selection__favorites">
            <MyLists {...myListProps} isPDPpage />
          </div>
        )}
      </div>

      {/* Error Warning - BEM Element - Below main row */}
      {shouldShowError && (
        <div className="product-quantity-selection__error" data-testid="product-quantity-selection__error">
          <Warning {...warningProps} />
        </div>
      )}

      <style jsx>{ProductQuantitySelectionContainerStyle}</style>
    </div>
  );
};

ProductQuantitySelectionContainer.defaultProps = {
  addToCartButtonVisible: true,
  errorAddingToCart: false,
  isAddToCartInProgress: false,
  handleAddToCart: noop,
  handleRemoveFromCart: noop,
  isRemoveFromCartInProgress: false,
  sizes: [],
  selectedSize: '',
  showLoginForm: false,
  m2AttributeValue: -1,
  layout: 'hardline',
  appCtx: {},
  product: {},
};

ProductQuantitySelectionContainer.propTypes = {
  maxCartQuantity: PropTypes.number.isRequired,
  addToCartButtonVisible: PropTypes.bool,
  errorAddingToCart: PropTypes.bool,
  isAddToCartInProgress: PropTypes.bool,
  handleRemoveFromCart: PropTypes.func,
  isRemoveFromCartInProgress: PropTypes.bool,
  labels: PropTypes.object.isRequired,
  handleAddToCart: PropTypes.func,
  isVendorLogin: PropTypes.bool.isRequired,
  sizes: PropTypes.array,
  selectedSize: PropTypes.string,
  setShowLoginForm: PropTypes.func.isRequired,
  showLoginForm: PropTypes.bool,
  setErrorAddingToCart: PropTypes.func.isRequired,
  m2AttributeValue: PropTypes.number,
  layout: PropTypes.string,
  appCtx: PropTypes.object,
  product: PropTypes.object,
};

export default ProductQuantitySelectionContainer;
export { ProductQuantitySelectionContainer };
